import { useHover } from 'ahooks';
import { ITemplateInfoView } from 'apis/models';
import AnimationPlayer from 'components/AnimationPlayer';
import React, { FC, useRef } from 'react';
import './index.less';

interface IGcCardProps {
  onPreview?: () => void;
  onUse?: () => void;
  record: ITemplateInfoView;
}
const GcCard: FC<IGcCardProps> = (props) => {
  const { onPreview, onUse, record } = props;
  const ref = useRef(null);
  const isHovering = useHover(ref);
  return (
    <div className="gc-card">
      <div className="gc-show" ref={ref} onClick={() => onPreview?.()}>
        <div className="gc-show-inner">
          <AnimationPlayer
            src={record.gifUrl}
            loop
            isPlaying={isHovering}
            time={2000}
            fps={60}
            posterUrl={record.cover}
          />
        </div>
      </div>
      <div className="gc-title ellips">{record.name}</div>
      <div className="gc-use" onClick={() => onUse?.()}>
        使用模板
      </div>
    </div>
  );
};

export default GcCard;
